import { render, staticRenderFns } from "./ProductCogsList.vue?vue&type=template&id=2f7a1e5c&"
import script from "./ProductCogsList.vue?vue&type=script&lang=js&"
export * from "./ProductCogsList.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports